import { render, staticRenderFns } from "./products.component.vue?vue&type=template&id=dea4e84c&scoped=true&"
import script from "./products.component.vue?vue&type=script&lang=js&"
export * from "./products.component.vue?vue&type=script&lang=js&"
import style0 from "./products.component.vue?vue&type=style&index=0&id=dea4e84c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dea4e84c",
  null
  
)

export default component.exports